import React from 'react';

import { UserType } from '../../types';
import TableHeader from './TableHeader';

interface UserTableProps {
  userType: UserType;
  children?: React.ReactNode;
}

const UserTable = ({ userType, children }: UserTableProps) => {
  return (
    <table className="mt-28 w-full">
      <TableHeader userType={userType} />
      <tbody>{children}</tbody>
    </table>
  );
};

export default UserTable;
